<template>
  <v-card style="min-width:650px;" elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">person_add</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">Direct learner join URL for {{ section.name }}.</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <div class="tab-item-container">
      <div class="class-info-container">
        <div class="preview-info">
          <span>This URL will first direct students to signup for or login to a Playposit account. Then learners will be redirected to this class in their learner dash.
            <br/>Learners will be added to the class if they are not already in it.</span>
        </div>
      </div>
      <div class="copy-container">
        <v-text-field 
          box
          hide-details
          readonly
          :value="learnerJoinUrl"></v-text-field>
        <ClipboardCopy :copyText="learnerJoinUrl"></ClipboardCopy>
      </div>
    </div>
    <div
      v-if="hasSamlLogin"
      class="advanced-container"
    >
      <a
        @click="showAdvancedSettings = !showAdvancedSettings"
        class="link-button"
      >
        Advanced settings
      </a>
      <v-container
        v-show="showAdvancedSettings"
        pl-3
        pt-0
      >
        <v-layout>
          <v-flex>
            <v-switch
              v-model="samlLogin"
              label="Require SAML Login"
              height="30"
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-card-actions class="row-space" style="height:56px">
     <v-btn
      flat
      class="branded-grey"
      @click="setDashModal(null)"
      >Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import _ from 'lodash';
import ClipboardCopy from '@/components/buttons/clipboardCopy';

export default {
  name: 'DirectClassURL',
  components: {
    ClipboardCopy,
  },
  props: [
    'schoolId',
    'sectionId', 
  ],
  data: () => ({
    facilitatorCopyBox: {
      flexDirection: 'row',
      flex: 'none',
    },
    samlLogin: false,
    showAdvancedSettings: false,
  }),
  computed: {
    ...mapState('instructors', [
      'classes',
    ]),
    ...mapGetters([
      'instructorData',
      'phpApiPrefix',
      'school',
    ]),
    ...mapGetters('instructors', [
      'hasSamlLogin',
      'hasIdpLearnerUrl',
    ]),
    learnerJoinUrl() {
      if (this.samlLogin) {
        if (this.hasIdpLearnerUrl) {
          return `${this.phpApiPrefix}/saml/${this.school.id}/learner?redirect=/r/join/0/${this.instructorData.id}/${this.sectionId}`;
        }
        // Normal SAML login flow, doesn't enforce a specific user role type.
        else {
          return `${this.phpApiPrefix}/saml/${this.school.id}?redirect=/r/join/0/${this.instructorData.id}/${this.sectionId}`;
        }
      }
      if (this.schoolId === 2710) {
        return `https://ntc.playposit.com?sectionId=${this.sectionId}`;
      }
      return `${this.phpApiPrefix}/account/learner/login?sectionId=${this.sectionId}${this.schoolId ? '&schoolId=' + this.schoolId : ''}`;
    },
    section() {
      return _.find(this.classes.data, { id: this.sectionId });
    },
  },
  methods: {
    ...mapMutations([
      'setDashModal',
    ]),
  },
  mounted() {
    this.samlLogin = this?.school?.permissionKeys?.includes('enableSamlByDefault');
    if (this.samlLogin) this.showAdvancedSettings = true;
  },
};
</script>
